import React from "react"

import CloudflareBasicStream from "../_base/CloudflareBasicStream"

import { ChildSelector } from "../../helpers/ChildSelector"

import * as multiVideoDisplayStyles from "../../styles/beyond_spreadsheet/MultiVideoDisplay.module.css"

export default function MultiVideoDisplay(props) {
  const { content } = props

  const heading = ChildSelector.select(
    content,
    `extra-heading`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const youtubeVideos = ChildSelector.select(
    content,
    `youtube-video`,
    ChildSelector.SELECTOR_TYPE.ARRAY,
  )

  const cards = ChildSelector.select(
    content,
    `extra-video-card`,
    ChildSelector.SELECTOR_TYPE.ARRAY,
  ).map(card => ({
    holder: card,
    title: ChildSelector.select(
      card,
      `extra-video-card-title`,
      ChildSelector.SELECTOR_TYPE.INNER_HTML,
    ),
    location: ChildSelector.select(
      card,
      `extra-video-card-location`,
      ChildSelector.SELECTOR_TYPE.INNER_HTML,
    ),
    date: ChildSelector.select(
      card,
      `extra-video-card-date`,
      ChildSelector.SELECTOR_TYPE.INNER_HTML,
    ),
    stream: ChildSelector.select(
      card,
      `extra-video-card-stream`,
      ChildSelector.SELECTOR_TYPE.TEXT,
    ),
    youtube: ChildSelector.select(
      card,
      `extra-video-card-youtube`,
      ChildSelector.SELECTOR_TYPE.INNER_HTML,
    ),
    poster: ChildSelector.select(
      card,
      `extra-video-card-poster`,
      ChildSelector.SELECTOR_TYPE.TEXT,
    ),
  }))

  return (
    <>
      <div
        className={`row ${props.className} ${multiVideoDisplayStyles.wrapper}`}
      >
        <div className={`col-12 ${multiVideoDisplayStyles.innerWrapper}`}>
          <h1>{heading}</h1>
        </div>
        {cards &&
          cards.map((card, idx) => (
            <div
              key={idx}
              className={`row ${multiVideoDisplayStyles.videoCard}`}
            >
              <div
                className={`col-sm-12 col-md-12 col-lg-6 ${multiVideoDisplayStyles.film}`}
              >
                {card.youtube && (
                  <div
                    className={`${multiVideoDisplayStyles.youtube}`}
                    dangerouslySetInnerHTML={{ __html: card.youtube }}
                  />
                )}
                {card.stream && (
                  <CloudflareBasicStream
                    controls={true}
                    autoplay={false}
                    videoStreamId={card.stream}
                    poster={card.poster}
                  />
                )}
              </div>
              <div
                className={`col-sm-12 col-md-12 col-lg-6 ${multiVideoDisplayStyles.content}`}
              >
                <h2 dangerouslySetInnerHTML={{ __html: card.title }} />
                <h4 dangerouslySetInnerHTML={{ __html: card.location }} />
                <p dangerouslySetInnerHTML={{ __html: card.date }} />
              </div>
            </div>
          ))}
      </div>
    </>
  )
}
